import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Row, Table } from 'reactstrap';
import { Formik } from 'formik';
import ErrorBoundary from 'components/ErrorBoundary';
import { onExport } from 'utils/helper';
import HistoricaldetailsTable from './HistoricaldetailsTable';
import useAxios from 'hooks/useAxios';

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "ndc",
    order: "desc",
    filters: [],
    AccumulatorIDs: [],
    AccountTypeID: 0,
    POStatusID: 0,
    Invoice: "",
    Poid: 0,
};


const NDCAccumulationDetails = ({ rowData, tenantID }) => {
    debugger;
    const API = useAxios();
    const [state, updateState] = useState({
        data: [],
        loading: false,
        records: 0,
        reset: false,
    });
    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
    const [colFilter, setColFilter] = useState([]);

    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: "ndc",
            order: "desc",
            filters: [],
            AccumulatorIDs: [],
            AccountTypeID: 0,
            POStatusID: 0,
            Invoice: "",
            Poid: 47431,
        };
        setState({ data: [], records: 0 });
        if (rowData) {
           
            var acIds = [];
            const { accumulatorID } = rowData;
            acIds= accumulatorID;
            initialFilters.AccumulatorIDs = [acIds];
            initialFilters.currentPage = 1;
            fetchPurchaseDetails(initialFilters);
        }
    }, []);

    const fetchPurchaseDetails = async (pageDetails = {}, hasColumnFilter) => {
        debugger
        setState({ loading: true });
        let filter = { ...pageDetails };
        if (hasColumnFilter) {
            filter.filters = [...initialFilters.filters, ...pageDetails.filters];
            //initialFilters.filters = [...filter.filters];
        } else {
            initialFilters = { ...initialFilters, ...filter };
        }
        try {
            const { data } = await API.post(
                `SBTenant/${tenantID.tenantID}/Inventory/GetNdcHyperLink/${rowData.ndc}`, filter,
                {
                    hasDefaultURL: true,
                    hideLoder: true,
                });
            if (data) {
                debugger;
                console.log(data.items);
                setState({
                    data: data.items,
                    records: data.totalRecords,
                    loading: false,
                });
                // setTempData(data.items);
            } else {
                setState({
                    data: [],
                    records: 0,
                    loading: false,
                });
            }
        } catch (error) {
            setState({ loading: false, data: [], records: 0 });
        }
    };
    const handleSearchColumnFilters = async (columnFilters) => {
        setColFilter(columnFilters);
        await fetchPurchaseDetails({ ...initialFilters, ...columnFilters }, true);
    };

    const onPageChange = (filter, hasFilter) => {
        if (hasFilter) {
            fetchPurchaseDetails(filter, true);
        } else {
            fetchPurchaseDetails(filter);
        }
    };

    const refetch = (hasReset) => {
        if (hasReset) {
            setColFilter([]);
            initialFilters = {
                ...initialFilters,
                currentPage: 1,
            };
        }
        fetchPurchaseDetails(initialFilters);
    };
    const handleExport = async () => {
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        onExport(action, initialFilters);
    };
    

    return (
        <div>
            <div>
                <Card>
                    <CardBody className='section-devider-border'>
                        <Row>
                            <Col md="6" className='d-flex'>
                                <p className="m-0 f-14 mt-1">NDC :</p>
                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{state.data.length == 0 ?rowData.ndc : state?.data[0]?.ndc}</p>
                            </Col>
                            <Col md="6" className='d-flex'>
                                <p className="m-0 f-14 mt-1">Drug Name  : </p>
                                <p className="m-0 f-14 font-weight-500 mt-1 ms-1">{state.data.length == 0 ?rowData?.drugName || rowData?.ndcDescription || rowData?.drugDescription:state?.data[0]?.drugName}</p>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardBody className='section-devider-border'>
                        <ErrorBoundary>
                            <HistoricaldetailsTable
                                data={state.data}
                                loading={state.loading}
                               // onExport={handleExport}
                                totalSize={state.records}
                                filters={initialFilters}
                                onPageChange={onPageChange}
                                setLoading={(value) => setState({ loading: value })}
                                onSearchColumnFilters={handleSearchColumnFilters}
                                refetch={refetch}
                            />
                        </ErrorBoundary>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default NDCAccumulationDetails
